
<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>

<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
      <mat-card-title><mat-icon matListIcon>work_outline</mat-icon>Ofertas Laborales</mat-card-title>
    </mat-card-header-->
    <mat-card-content>

	<div id="fieldsContainer">
		<mat-accordion class="iconTitle" multi>
			<mat-expansion-panel #advancedPanel >
				<mat-expansion-panel-header>
					<mat-panel-title>
						<mat-icon>find_in_page</mat-icon>B&uacute;squeda Avanzada
					</mat-panel-title>
				</mat-expansion-panel-header>
				<div id="container" class="formControl">
					<div class="control">
						<mat-form-field class="imput-full-width">
						<mat-label>Folio</mat-label>
						<input type="text" matInput name="filterOffer.f" [(ngModel)]="filterOffer.f">
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
							<mat-label>Nombre</mat-label>
							<input matInput type="text" name="filterOffer.n" [(ngModel)]="filterOffer.n">
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
							<mat-label>Apellido Paterno</mat-label>
							<input matInput type="text" name="filterOffer.ps" [(ngModel)]="filterOffer.ps">
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
							<mat-label>Apellido Materno</mat-label>
							<input matInput type="text" name="filterOffer.ms" [(ngModel)]="filterOffer.ms">
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
						<mat-label>Division</mat-label>
						<mat-select [(ngModel)]="filterOffer.d" name="filterOffer.d">
							<mat-option [value]="-1">Todas las areas</mat-option>
							@for (division of divisions; track division.id) {
							<mat-option [value]="division.id">{{ division.description }}</mat-option>
							}
						</mat-select>
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
						<mat-label>Area</mat-label>
						<mat-select [(ngModel)]="filterOffer.a" name="filterOffer.a">
							<mat-option [value]="-1">Todas las divisiones</mat-option>
							@for (area of areas ; track area.id) {
							<mat-option [value]="area.id">{{ area.description }}</mat-option>
							}
						</mat-select>
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
						<mat-label>Activo</mat-label>
						<mat-select  name="filterOffer.ac" [(ngModel)]="filterOffer.ac">
							<mat-option value="-1">Todos</mat-option>
							<mat-option value="1">Activas</mat-option>
							<mat-option value="0">Inactivas</mat-option>
						</mat-select>
						</mat-form-field>
					</div>
				</div>
				<div id="buttonContainer">
					<button mat-flat-button class="button" (click)="searchOffersPaginatorAS()">
						<mat-icon>search</mat-icon>Consultar
					</button>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
	</div>
	<br>
	<div id="tableContainer">
		<app-table #offersTable  
			(paginatorEvent)="paginatorEvent($event)"
			(editEvent)="editEvent($event)"
			[tableModel]="tableModel">
		</app-table>
	</div>

	</mat-card-content>
	<mat-card-footer class="general-wf-card-footer">
	</mat-card-footer>
</mat-card>